<template>
  <Modal class="dea-modal-main-role dea-modal--no-footer" :visible="visible" @modalClose="$emit('close-modal')">
    <template slot="title">
      Aggiungi il tuo ruolo
    </template>
    <template slot="content">
      <div class="dea-modal-main-role__roles-list">
        <Checkbox
          v-for="(role, index) in $root.config.schoolRoles"
          :id="`role-${index}`"
          :key="index"
          class="dea-checkbox--regular"
          name="schoolRole"
          type="radio"
          @change="updateSelectedRole(role)"
        >
          {{ role }}
        </Checkbox>
      </div>
      <div class="dea-modal-main-role__small-message dea-heading--regular-xs">
        La tua agenzia di zona confermerà il tuo ruolo. Rimarrà a tua disposizione anche per gli aggiornamenti futuri.
      </div>
      <div class="dea-modal-delete-school__buttons dea-modal-buttons">
        <Buttons class="dea-button--large" @click="saveNewRole()">Salva modifiche</Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions } from "vuex";

import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import Modal from "@/components/patterns/Modal";
import User from "~/clients/user";

export default {
  name: "MainSchoolRoleModal",
  components: { Buttons, Checkbox, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRole: "",
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async saveNewRole() {
      if (this.selectedRole) {
        document.querySelector("body").classList.add("wait");
        try {
          await User.modifyUserEntities(this.$root.config, this.user.id, { main_school_roles: [this.selectedRole] });
          await this.fetchUser(true);
          document.querySelector("body").classList.remove("wait");
        } catch (e) {
          Sentry.captureException(e);
          document.querySelector("body").classList.remove("wait");
        }
        this.$emit("close-modal");
      }
    },
    updateSelectedRole(role) {
      this.selectedRole = role;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal-main-role {
  &__small-message {
    margin-top: $space-base;
  }
}
</style>
